export default "__VITE_ASSET__rv3_lG2T__"